<template>
  <div class="featured">
    <div class="container">
      <img :src="featured.image" alt height="768" class="hide-mobile" />
      <img :src="featured.image_bg_mobile" alt class="hide-desktop background-mobile" />

      <div class="featured-content">
        <div class="featured-area" v-html="featured.area" />
        <div class="featured-title" v-html="featured.title" />
        <img :src="featured.image_mobile" class="hide-desktop" />
        <div class="featured-desc" v-html="featured.text" />
        <div
          class="view-more"
          v-scroll-to="{
            el: `.video`,
            offset: -120,
            force: true,
          }"
        >
          {{ featured.arrow }}
          <span>
            <v-icon name="chevron-down" />
          </span>
        </div>
      </div>

      <div class="abb">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44.102"
          height="22.662"
          viewBox="0 0 44.102 22.662"
        >
          <g id="Grupo_12" data-name="Grupo 12" transform="translate(-139 -710.478)">
            <rect
              id="Retângulo_10"
              data-name="Retângulo 10"
              width="15.734"
              height="2.709"
              transform="translate(139 710.478)"
              fill="#fff"
            />
            <g id="Grupo_4" data-name="Grupo 4" transform="translate(139.838 720.088)">
              <path
                id="Caminho_22"
                data-name="Caminho 22"
                d="M1338.844,996.779V986.742h1.272v4.23a2.674,2.674,0,0,1,1.013-1.026,2.828,2.828,0,0,1,1.437-.37,2.926,2.926,0,0,1,1.676.5,3.265,3.265,0,0,1,1.129,1.333,4.322,4.322,0,0,1,.4,1.871,4.238,4.238,0,0,1-.431,1.94,3.193,3.193,0,0,1-1.156,1.3,2.983,2.983,0,0,1-1.615.454,2.908,2.908,0,0,1-1.443-.363,2.7,2.7,0,0,1-1.033-1.02v1.187Zm3.461-.963a1.951,1.951,0,0,0,1.129-.342,2.213,2.213,0,0,0,.766-.915,3,3,0,0,0,.266-1.284,2.9,2.9,0,0,0-.294-1.334,2.245,2.245,0,0,0-.779-.893,1.956,1.956,0,0,0-1.088-.314,2.054,2.054,0,0,0-1.169.342,2.28,2.28,0,0,0-.794.914,2.887,2.887,0,0,0-.28,1.285,2.843,2.843,0,0,0,.3,1.333,2.217,2.217,0,0,0,.814.894A2.124,2.124,0,0,0,1342.305,995.816Z"
                transform="translate(-1338.844 -986.742)"
                fill="#fff"
              />
              <path
                id="Caminho_23"
                data-name="Caminho 23"
                d="M1352.414,998.157a7.582,7.582,0,0,1-.753,1.494,2.25,2.25,0,0,1-.861.768,2.8,2.8,0,0,1-1.218.236,3.055,3.055,0,0,1-.588-.055,1.257,1.257,0,0,1-.438-.154l.192-1.075a1.98,1.98,0,0,0,.78.126,1.542,1.542,0,0,0,1.019-.314,2.557,2.557,0,0,0,.663-1.069l.178-.46-2.791-7.036h1.354l2.011,5.529,2.026-5.529h1.34Z"
                transform="translate(-1341.099 -987.604)"
                fill="#fff"
              />
              <path
                id="Caminho_24"
                data-name="Caminho 24"
                d="M1366.906,987.622l3.53,9.353h-1.464l-.848-2.415h-3.955l-.835,2.415h-1.451l3.53-9.353Zm-2.326,5.751h3.133l-1.56-4.5Z"
                transform="translate(-1344.193 -986.938)"
                fill="#fff"
              />
              <path
                id="Caminho_25"
                data-name="Caminho 25"
                d="M1374.767,987.622h3.12a3.555,3.555,0,0,1,2.223.628,2.067,2.067,0,0,1,.815,1.731,2.294,2.294,0,0,1-.287,1.159,1.96,1.96,0,0,1-.834.782,2.644,2.644,0,0,1,1.4.852,2.324,2.324,0,0,1,.486,1.508q0,2.695-3.626,2.694h-3.3Zm3.147,3.867q1.711,0,1.711-1.368a1.177,1.177,0,0,0-.451-1,2.2,2.2,0,0,0-1.341-.341h-1.724v2.708Zm.137,4.313a3.212,3.212,0,0,0,1.745-.369,1.3,1.3,0,0,0,.553-1.166q0-1.633-2.3-1.633h-1.943V995.8Z"
                transform="translate(-1347.184 -986.938)"
                fill="#fff"
              />
              <path
                id="Caminho_26"
                data-name="Caminho 26"
                d="M1386.171,987.622h3.12a3.558,3.558,0,0,1,2.224.628,2.067,2.067,0,0,1,.814,1.731,2.3,2.3,0,0,1-.287,1.159,1.958,1.958,0,0,1-.835.782,2.646,2.646,0,0,1,1.4.852,2.323,2.323,0,0,1,.485,1.508q0,2.695-3.626,2.694h-3.3Zm3.147,3.867q1.71,0,1.71-1.368a1.179,1.179,0,0,0-.451-1,2.207,2.207,0,0,0-1.342-.341h-1.724v2.708Zm.136,4.313a3.21,3.21,0,0,0,1.745-.369,1.3,1.3,0,0,0,.554-1.166q0-1.633-2.3-1.633h-1.943V995.8Z"
                transform="translate(-1349.831 -986.938)"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["featured"],
};
</script>

<style lang="scss" src="./Featured.scss" />